import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="image" width="100%" theme="lightest" alignment="yes" className="sale-support-img div-p-0 mediaSize w-50 sale-support-img" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/705b910e048fb10439f7f5f7182b1e3d/2_Icon_Sales.svg",
        "alt": "adobe-sales",
        "title": " "
      }}></img></p>
    <TextBlock slots="heading,text1, text2, buttons" width="100%" theme="lightest" alignment="yes" className=" py-0  div-p-0  link linking contact-sales sale-support-btn-align" mdxType="TextBlock" />
    <h3 {...{
      "id": "sales"
    }}>{`Sales`}</h3>
    <p><strong parentName="p">{`Pricing, Billing, and Licensing`}</strong></p>
    <p><a parentName="p" {...{
        "href": "/document-services/faq/sales/"
      }}>{`Visit our Sales FAQ`}</a></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./sales.md"
        }}>{`Contact Us`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      